Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityTeamSelectView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_team_select']
  className: 'operator-availability-team-select'

  initialize: ->
    @teamID = ''
    @teams = new Customer.OperatorGroupCollection([
      id: ''
      name: I18n.t('customer.reports.operator_availability.all_groups')
    ])

  render: =>
    @$el.html(@template(teams: @teams, selectedTeamID: @teamID))
    @$el.find('select').chosen(width: '375px').change (event) =>
      @teamID = event.target.value
      @trigger('change', teamID: @teamID)
    @

  enable: =>
    @$el.find('select').prop('disabled', false).trigger('chosen:updated')

  disable: =>
    @$el.find('select').prop('disabled', true).trigger('chosen:updated')

  fetchTeams: =>
    @teams.fetch
      remove: false
      success: @render
      error: -> showError(I18n.t('generic_error_message'))
